var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getTranslation from '../../../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { getCancelPaymentAnalyticsProps } from '../../../../const/analytics/cancel-payment';
import { StyledCloseButton } from '../../../../styles/buttons';
import { StyledTitle } from '../../../../styles/text';
import { ModalOptions } from '../../../../typings/activity/modal-types';
import { StyledModalHeader } from '../../modal/subcomponents';
var CancelPaymentModalHeader = function (_a) {
    var closeModal = _a.closeModal, currentModal = _a.currentModal;
    var t = getTranslation().t;
    return (_jsxs(StyledModalHeader, { alignItems: "center", justifyContent: "space-between", children: [_jsx(RenderIf, { condition: currentModal === ModalOptions.default, children: _jsx(StyledTitle, { id: "slide-in-modal-portal", children: t('activityDetails.activityDetailHeader') }) }), _jsx(RenderIf, { condition: currentModal === ModalOptions.cancelComplete, children: _jsx(StyledTitle, { id: "slide-in-modal-portal", children: t('activityDetails.cancelPayment.paymentCanceledHeading') }) }), _jsx(RenderIf, { condition: currentModal === ModalOptions.cancelInitiated, children: _jsx(StyledTitle, { id: "slide-in-modal-portal", children: t('activityDetails.cancelPayment.cancelPaymentHeading') }) }), _jsx(RenderIf, { condition: currentModal === ModalOptions.cancelConfirm ||
                    currentModal === ModalOptions.cancelError, children: _jsx(StyledTitle, { id: "slide-in-modal-portal", children: t('activityDetails.cancelPayment.cancelPaymentHeading') }) }), currentModal !== ModalOptions.cancelInitiated && (_jsx(StyledCloseButton, __assign({ "aria-label": "close" }, getCancelPaymentAnalyticsProps('xButton'), { onClick: function () {
                    // delay added to wait for analytics event to be send
                    setTimeout(function () {
                        closeModal();
                    }, 0);
                }, children: _jsx(FontAwesomeIcon, { icon: faClose, size: "1x" }) })))] }));
};
export default CancelPaymentModalHeader;
//# sourceMappingURL=index.js.map